import React from 'react'

import NarrativeItinerary from '../narrative-itinerary'
import ItineraryDetails from './itinerary-details'
import TripDetails from '../connected-trip-details'
import TripTools from '../trip-tools'

export default class DefaultItinerary extends NarrativeItinerary {
  render () {
    const {
      active,
      activeLeg,
      activeStep,
      expanded,
      itinerary,
      setActiveLeg,
      setActiveStep,
      dir
    } = this.props
    return (
      <div className={`option default-itin x${active ? ' active' : ''}`}>
   
        {(active || expanded) &&
          <div className='body'>
            <ItineraryDetails
              itinerary={itinerary}
              activeLeg={activeLeg}
              activeStep={activeStep}
              setActiveLeg={setActiveLeg}
              setActiveStep={setActiveStep}
              dir={dir}
            />
            <TripDetails itinerary={itinerary} />
            <TripTools itinerary={itinerary} />
          </div>
        }
      </div>
    )
  }
}
